import { Box, Flex } from '@mantine/core'

import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

import classes from './AdvisorWorkspacePlaceholder.module.css'

export function AdvisorWorkspacePlaceholder() {
  return (
    <Flex className={classes.container}>
      <Box>
        <Title variant="h1">Work with a planner</Title>

        <Text variant="body_2_medium_black">
          Chat with a planner to get personalized advice on your finances. Your
          planner can help you with a wide range of financial topics, including
          healthcare benefits selections, budgets, debt payment plans, or
          investments, to name a few. No question is too big or small, and you
          get unlimited access to your planner, at no charge to you!
        </Text>
      </Box>
    </Flex>
  )
}
